enum PermissionType {
	plain = "plain",
	all = "all",
}

export default PermissionType;
